import { Component, OnInit } from '@angular/core';
import { OrderDetail } from '../../../models/OrderDetail';
import { OrderHistory } from '../../../models/OrderHistory';
import { HttpService } from '../../../services/HttpService';
import { HttpResponse } from '@angular/common/http';
import { ReportParameter, ReportRequestObject } from '../../../models/ReportRequestObject';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import { GlobalService } from '../../../services/global';
import { OrderDetailShipment } from '../../../models/OrderDetailShipment';
import { Invoice } from '../../../models/Invoice';
import { Utilities } from '../../../models/Utilities';
import { User } from '../../../models/User';

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.css']
})
export class OrderSummaryComponent implements OnInit {
  order: OrderHistory;
  detail: OrderDetail;
  hideLoadingModal: boolean;
  faFileLines = faFileLines;
  CurrentUser: User;
  ShipmentIDList: string[];
  constructor(private http:HttpService, private global:GlobalService) { }

  ngOnInit(): void {
    this.hideLoadingModal = true;
    this.global.getCurrentUser().then(x => {
      this.CurrentUser = x;
      this.global.getCurrentDist().then(dist => {
        this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Order Detail Summary", "Load", this.order.OrderNumber, this.CurrentUser.IsTolomaticUser ? dist.CompanyId : this.CurrentUser.DistributorId);    
      });
      
    });
    
  }

  SetupShipmentLinks() {
    this.ShipmentIDList = [];
    if (this.detail.Shipments && this.detail.Shipments.length > 0) {
      this.detail.Shipments.forEach(x => {
        if (this.ShipmentIDList.indexOf(x.ShipmentID) < 0) {
          this.ShipmentIDList.push(x.ShipmentID);
        }
      });
    }
  }

  DownloadVerification() {
    this.hideLoadingModal = false;
    if (this.order.OrderVerificationPath.length > 0) {
      this.global.getCurrentDist().then(dist => {
        this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Order Detail Summary", "Download Order Verification", this.order.OrderNumber, this.CurrentUser.IsTolomaticUser ? dist.CompanyId : this.CurrentUser.DistributorId);
      });
      
      this.http.DownloadOrderVerification(this.order.OrderNumber).subscribe(({ body, headers }: HttpResponse<any>) => {
        debugger;
        var contentType = headers.get('content-type');
        const blob = new Blob([body], { type: contentType });
        var fileURL = URL.createObjectURL(blob);

        var a = document.createElement("a");
        a.href = fileURL;
        a.download = this.order.OrderNumber + ".pdf";
        a.click();
        this.hideLoadingModal = true;
      });
    }
  }

  DownloadInvoiceReport(invoice:Invoice) {
    this.hideLoadingModal = false;
    this.http.DownloadInvoice(invoice.InvoiceNumber).subscribe(({ body, headers }: HttpResponse<any>) => {
      debugger;
      var contentType = headers.get('content-type');
      const blob = new Blob([body], { type: contentType });
      var fileURL = URL.createObjectURL(blob);

      var a = document.createElement("a");
      a.href = fileURL;
      a.download = invoice.InvoiceNumber + ".pdf";
      a.click();
      this.hideLoadingModal = true;
    });
    //var reportRequest = new ReportRequestObject();
    //reportRequest.ReportPath = "/SLReports/_TOL_ConsolidatedInvoicingLaser_NonSL";
    //var estStarting = new ReportParameter();
    //estStarting.Key = "pBegInvNum";
    //estStarting.Value = invoice.InvoiceNumber;
    //var estEnding = new ReportParameter();
    //estEnding.Key = "pEndInvNum";
    //estEnding.Value = invoice.InvoiceNumber;
    //var sessionIDChar = new ReportParameter();
    //sessionIDChar.Key = "pSessionIdChar";
    //sessionIDChar.Value = Utilities.GenerateGuidString();

    //reportRequest.ReportParams.push(estStarting);
    //reportRequest.ReportParams.push(estEnding);
    //reportRequest.ReportParams.push(sessionIDChar);
    //this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Order Detail Summary", "Download Invoice Report", invoice.InvoiceNumber);
    //this.http.GetSQLReport(reportRequest).subscribe(({ body, headers }: HttpResponse<any>) => {
    //  debugger;
    //  var contentType = headers.get('content-type');
    //  const blob = new Blob([body], { type: contentType });
    //  var fileURL = URL.createObjectURL(blob);

    //  var a = document.createElement("a");
    //  a.href = fileURL;
    //  a.download = this.detail.OrderNumber; + ".pdf";
    //  a.click();
    //  this.hideLoadingModal = true;
    //});
  }


  DownloadPackingSlip() {
    this.hideLoadingModal = false;
    var reportRequest = new ReportRequestObject();
    reportRequest.ReportPath = "/SLReports/ShipmentPackingSlip_NonSL";
    var estStarting = new ReportParameter();
    estStarting.Key = "MinShipNum";
    estStarting.Value = this.detail.Shipments[0].ShipmentID;
    var estEnding = new ReportParameter();
    estEnding.Key = "MaxShipNum";
    estEnding.Value = this.detail.Shipments[0].ShipmentID;

    reportRequest.ReportParams.push(estStarting);
    reportRequest.ReportParams.push(estEnding);
    this.global.getCurrentDist().then(dist => {
      this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Order Detail Summary", "Download Packing Slip", this.detail.Shipments[0].ShipmentID, this.CurrentUser.IsTolomaticUser ? dist.CompanyId : this.CurrentUser.DistributorId);
    });
    
    this.http.GetSQLReport(reportRequest).subscribe(({ body, headers }: HttpResponse<any>) => {
      debugger;
      var contentType = headers.get('content-type');
      const blob = new Blob([body], { type: contentType });
      var fileURL = URL.createObjectURL(blob);

      var a = document.createElement("a");
      a.href = fileURL;
      a.download = this.detail.OrderNumber; + ".pdf";
      a.click();
      this.hideLoadingModal = true;
    });
  }

  DownloadShipmentPackingSlip(shipment: OrderDetailShipment) {
    if (shipment.ShipmentID) {
      this.hideLoadingModal = false;
      var reportRequest = new ReportRequestObject();
      reportRequest.ReportPath = "/SLReports/ShipmentPackingSlip_NonSL";
      var estStarting = new ReportParameter();
      estStarting.Key = "MinShipNum";
      estStarting.Value = shipment.ShipmentID;
      var estEnding = new ReportParameter();
      estEnding.Key = "MaxShipNum";
      estEnding.Value = shipment.ShipmentID;

      reportRequest.ReportParams.push(estStarting);
      reportRequest.ReportParams.push(estEnding);
      this.global.getCurrentDist().then(dist => {
        this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Order Detail Summary", "Download Packing Slip", shipment.ShipmentID, this.CurrentUser.IsTolomaticUser ? dist.CompanyId : this.CurrentUser.DistributorId);
      });
      
      this.http.GetSQLReport(reportRequest).subscribe(({ body, headers }: HttpResponse<any>) => {
        debugger;
        var contentType = headers.get('content-type');
        const blob = new Blob([body], { type: contentType });
        var fileURL = URL.createObjectURL(blob);

        var a = document.createElement("a");
        a.href = fileURL;
        a.download = this.detail.OrderNumber; + ".pdf";
        a.click();
        this.hideLoadingModal = true;
      });
    }
  }

  DownloadShipmentPackingSlipByID(shipmentID: string) {
    if (shipmentID) {
      this.hideLoadingModal = false;
      var reportRequest = new ReportRequestObject();
      reportRequest.ReportPath = "/SLReports/ShipmentPackingSlip_NonSL";
      var estStarting = new ReportParameter();
      estStarting.Key = "MinShipNum";
      estStarting.Value = shipmentID;
      var estEnding = new ReportParameter();
      estEnding.Key = "MaxShipNum";
      estEnding.Value = shipmentID;

      reportRequest.ReportParams.push(estStarting);
      reportRequest.ReportParams.push(estEnding);
      this.global.getCurrentDist().then(dist => {
        this.http.PostUserActivity(this.CurrentUser.UserId.toString(), "Order Detail Summary", "Download Packing Slip", shipmentID, this.CurrentUser.IsTolomaticUser ? dist.CompanyId : this.CurrentUser.DistributorId);
      });
      
      this.http.GetSQLReport(reportRequest).subscribe(({ body, headers }: HttpResponse<any>) => {
        debugger;
        if (headers != null && body != null) {
          var contentType = headers.get('content-type');
          const blob = new Blob([body], { type: contentType });
          var fileURL = URL.createObjectURL(blob);

          var a = document.createElement("a");
          a.href = fileURL;
          a.download = this.detail.OrderNumber; + ".pdf";
          a.click();
        }
        this.hideLoadingModal = true;
      });
    }
  }
}
